import {combineReducers} from 'redux';
import {reducer as companies} from 'data/companies';
import {reducer as counties} from 'data/counties';
import {reducer as ads} from 'data/ads';
import {reducer as search} from 'data/search';
import {reducer as userposition} from 'data/userposition';
import {reducer as categories} from 'data/categories';
import {reducer as formReducer} from 'redux-form'
import {reducer as auth} from 'data/auth'

const appReducer = combineReducers({
  companies,
  counties,
  categories,
  ads,
  auth,
  search,
  userposition,
  form: formReducer
});

const rootReducer = (state, action) => {
  if (action.type === "LOGOUT_SUCCESS") {
    state = undefined
  }

  return appReducer(state, action)
}

export default rootReducer


// WEBPACK FOOTER //
// src/reducers.js